import React from "react";
import matchSorter from "match-sorter";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Button from "@material-ui/core/Button/Button";
import AddIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Card from "../../../common/Card";
import ReactTable from "react-table";
import compose from "recompose/compose";
import {withStyles} from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import {getRaspaRecipes, newRaspaRecipe} from "../../../actions/raspaRecipeActions";
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import SaveAlt from "@material-ui/icons/SaveAlt";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Search from "@material-ui/icons/Search";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Remove from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8,
        width: '100%'
    },
    newRaspaRecipeTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
});

class RaspaBuffingStatsPerSaw extends React.Component {
    constructor(props) {
        super(props);
    };

    componentDidMount() {
    }

    getColumns() {
        return [
            {
                title: 'Raspa',
                field: 'raspaId',
                minWidth: 80
            },
            {
                title: 'Ciclo',
                field: 'raspaCicloSerraId',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['raspaCicloSerraId']}),
                filterAll: true,
                minWidth: 80
            },
            {
                title: 'Fabricante',
                field: 'Fabricante',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['Fabricante']}),
                filterAll: true,
                minWidth: 80
            },
            // {
            //     title: 'Modelo',
            //     id: 'sawModel',
            //     accessor: 'SawModel',
            //     filterMethod: (filter, rows) =>
            //         matchSorter(rows, filter.value, {keys: ['sawModel']}),
            //     filterAll: true,
            //     minWidth: 80
            // },
            {
                title: 'De',
                field: 'minData',
                Cell: cellInfo => (
                       convertISODateTimeToBRLocale(cellInfo.row.minData) ),
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['minData']}),
                filterAll: true,
                minWidth: 200
            },

            {
                title: '#Pneus',
                field: 'contador',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['contador']}),
                filterAll: true,
                minWidth: 200
            },
            {
                title: 'Milimetros Raspados',
                field: 'sumMilimetrosRaspados',
                Cell: cellInfo => (
                    Math.round(cellInfo.row.sumMilimetrosRaspados) ),
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['sumMilimetrosRaspados']}),
                filterAll: true,
                minWidth: 100
            },
            {
                title: 'Media Milimetros Raspados',
                field: 'mediaMilimetrosRaspados',
                Cell: cellInfo => (
                    Math.round(cellInfo.row.mediaMilimetrosRaspados) ),
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['mediaMilimetrosRaspados']}),
                filterAll: true,
                minWidth: 100
            }

        ];
    }

    render() {
        const { classes, series } = this.props;

         console.log("SERRA", series);

        return (
            <React.Fragment>
                {/*<div className={classes.dashboardCardSection}>*/}
                    <Card>
                        <MaterialTable
                            icons={tableIcons}
                            title="Estatistica por serra"
                            columns={this.getColumns()}
                            data={series}
                            options={{
                                filtering: false,
                                pageSize: 10,
                                pageSizeOptions: [10,15,25],
                                addRowPosition: 'first'
                            }}

                        />
                    </Card>
                {/*</div>*/}
            </React.Fragment>
        )
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RaspaBuffingStatsPerSaw)
